export const returnCompleteAddress = (addressObject) => (
  `${addressObject.number} ${addressObject.street}, ${addressObject.country}`
);